
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ToasterModel, TOASTER_TYPE } from '../../toaster.model';
import { ToasterService } from '../../toaster.service';

@Component({
  selector: 'toaster-item',
  standalone: true,
  imports: [],
  templateUrl: './toaster-item.component.html',
  styleUrl: './toaster-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToasterItemComponent {
  @Input() toaster?: ToasterModel;
  TOASTER_TYPE = TOASTER_TYPE;

  constructor(private toasterServ: ToasterService) {}

  closeIt(toasterID: string) {
    this.toasterServ.closeIt(toasterID);
  }
}
